import React, { useEffect, useState } from "react";
import GenericCrudPage from "../common/GenericCrudPage";
import { getModules, createModule, updateModule, deleteModule } from "../../../services/ModuleService";
import { getDepartments } from "../../../services/DepartmentService";
import { getLevels } from "../../../services/LevelService";
import { getSemesters } from "../../../services/SemesterService";
import { useTranslation } from "react-i18next";

// Modules définis sous les spécialités, puis affectés aux classes (menu d'actions d'une classe).
const Modules = () => {
  const { t } = useTranslation();
  const [departments, setDepartments] = useState([]);
  const [levels, setLevels] = useState([]);
  const [semesters, setSemesters] = useState([]);

  useEffect(() => {
    getDepartments({ page: 1, limit: 200 }).then((res) => setDepartments(res.data?.data || [])).catch(() => {});
    getLevels({ page: 1, limit: 200 }).then((res) => setLevels(res.data?.data || [])).catch(() => {});
    getSemesters({ page: 1, limit: 200 }).then((res) => setSemesters(res.data?.data || [])).catch(() => {});
  }, []);

  const label = (list, id) => list.find((x) => x.id === id)?.name || "-";
  const opts = (list) => list.map((x) => ({ value: x.id, label: x.name }));

  return (
    <GenericCrudPage
      permissionModule="TEACHING_MODULE"
      title={t("pages.modules.title")}
      breadcrumbLabel={t("pages.modules.breadcrumb")}
      addLabel={t("pages.modules.addLabel")}
      searchPlaceholder={t("common.ui.rechercherCodeNom")}
      defaultSort={{ by: "code", dir: "asc" }}
      api={{ list: getModules, create: createModule, update: updateModule, remove: deleteModule }}
      filters={[
        { key: "department_id", label: t("common.fields.allDepartments"), options: opts(departments) },
        { key: "semester_id", label: t("pages.subjects.allSemesters"), options: opts(semesters) },
      ]}
      columns={[
        { key: "code", label: t("common.fields.code"), sortable: true },
        { key: "name", label: t("common.fields.name"), sortable: true },
        { key: "department_id", label: t("common.fields.department"), render: (row) => label(departments, row.department_id) },
        { key: "level_id", label: t("common.fields.level"), render: (row) => (row.level_id ? label(levels, row.level_id) : "-") },
        { key: "semester_id", label: t("pages.subjects.semester"), render: (row) => (row.semester_id ? label(semesters, row.semester_id) : "-") },
        { key: "credits", label: t("pages.modules.credits"), render: (row) => row.credits ?? 0 },
        { key: "coefficient", label: t("pages.subjects.coefficientShort"), render: (row) => row.coefficient ?? "-" },
      ]}
      fields={[
        { key: "department_id", label: t("common.fields.department"), type: "select", required: true, options: opts(departments) },
        { key: "level_id", label: t("pages.subjects.levelOptional"), type: "select", options: opts(levels) },
        { key: "semester_id", label: t("pages.subjects.semesterOptional"), type: "select", options: opts(semesters) },
        { key: "code", label: t("common.fields.code"), type: "text", required: true, placeholder: "SP51", maxLength: 30 },
        { key: "name", label: t("common.fields.name"), type: "text", required: true, placeholder: t("pages.modules.namePlaceholder"), maxLength: 150 },
        { key: "credits", label: t("pages.modules.credits"), type: "number", placeholder: "3" },
        { key: "coefficient", label: t("pages.subjects.coefficientShort"), type: "number", placeholder: "1" },
        { key: "description", label: t("common.fields.description"), type: "textarea" },
        { key: "is_active", label: t("common.crud.statusActive"), type: "checkbox" },
      ]}
      buildPayload={(formData) => ({
        department_id: formData.department_id,
        level_id: formData.level_id || null,
        semester_id: formData.semester_id || null,
        code: formData.code.trim(),
        name: formData.name.trim(),
        credits: formData.credits !== "" && formData.credits != null ? Number(formData.credits) : 0,
        coefficient: formData.coefficient !== "" && formData.coefficient != null ? Number(formData.coefficient) : 1,
        description: formData.description || null,
        is_active: formData.is_active,
      })}
    />
  );
};

export default Modules;
